import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@mui/material';
import { CustomSelectAndChildren } from '../../../../../../../../components/CustomSelectAndChildren';
import { CustomTextField } from '../../../../../../../../components/CustomTextField';
import { BONUS_TYPE_ENUM } from '../Model/Model';
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */
const BonusScope = ({ rule, updateRule, emptyFields, isValid, disabled }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='col-12 px-0'>
                <CustomSelectAndChildren
                    id='slt_bns_type'
                    name='bonusType'
                    trans='bonus_type'
                    value={rule.bonusType ?? ''}
                    required
                    emptyFields={emptyFields}
                    showNoSelectionOption={false}
                    onChange={(e) => updateRule(e.target.name, e.target.value)}
                    disabled={disabled}
                >
                    {BONUS_TYPE_ENUM.values().map((b) => (
                        <MenuItem key={b.key} value={b.key}>{t(b.trans)}</MenuItem>
                    ))}
                </CustomSelectAndChildren>
            </div>
            <div className='col-12 px-0'>
                <CustomTextField
                    id='txt_bs_threshold'
                    name='value'
                    value={rule.value}
                    trans='threshold'
                    type='text'
                    required
                    emptyFields={emptyFields}
                    onChange={(e) => updateRule(e.target.name, e.target.value)}
                    isValid={isValid}
                    isValidText={t("value_cannot_exceed_x", { value: 100 })}
                    suffixText={<p className={"ibl-font-w-600 text-uppercase"}>%</p>}
                    length={3}
                    decimal={2}
                    disabled={disabled}
                />
            </div>
        </>
    );
};

export default BonusScope;
